import { getContractOptionIdByValue } from "./contracts";
import type { FieldOption, FileUploadDefinition, IntakeField, IntakeGuard, IntakeStep, RepeaterField } from "../types";

export function targetIdForStep(step: Pick<IntakeStep, "id">): string {
  return `step.${step.id}`;
}

export function targetIdForField(field: Pick<IntakeField, "path">): string {
  return `field.${field.path}`;
}

export function targetIdForGuard(guard: Pick<IntakeGuard, "path">): string {
  return `guard.${guard.path}`;
}

export function targetIdForUpload(upload: Pick<FileUploadDefinition, "id">): string {
  return `upload.${upload.id}`;
}

export function targetIdForRepeater(repeater: Pick<RepeaterField, "path">): string {
  return `repeater.${repeater.path}`;
}

export function targetIdForRepeaterField(repeater: Pick<RepeaterField, "path">, field: RepeaterField["fields"][number]): string {
  return `repeaterField.${repeater.path}.${field.path}`;
}

export function targetIdForFieldOption(field: Pick<IntakeField, "path">, option: FieldOption): string {
  if (field.path === "contract.contractType") return getContractOptionIdByValue(option.value) ?? `option.contract.${stableValueKey(option.value)}`;
  return option.id ?? `option.${field.path}.${stableValueKey(option.value)}`;
}

export function targetIdForRepeaterFieldOption(repeater: Pick<RepeaterField, "path">, field: RepeaterField["fields"][number], option: FieldOption): string {
  return option.id ?? `option.${repeater.path}.${field.path}.${stableValueKey(option.value)}`;
}

export function stableValueKey(value: string): string {
  const normalized = value.trim().toLowerCase().replace(/[^a-z0-9_-]+/g, "_").replace(/^_+|_+$/g, "");
  if (normalized && /[a-z0-9]/.test(normalized)) return normalized.slice(0, 48);
  return `v_${hashText(value)}`;
}

export function hashText(value: string): string {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(16);
}
